import {
    IDocument,
    Intake,
    Program,
    ProjectBrowserModel,
    ProjectModel,
    ResearchArea,
    User,
} from '../../../store/types';

import { UserRole } from 'susy-common/models';

export enum SupervisorType { //important to be the same as on backend
    Internal = 'Internal',
    External = 'External',
}

export interface SupervisorData {
    supervisor: User;
    supervisorType: SupervisorType;
    numberOfResearchFields: number;
    nextDueGradingDate: Date | null;
    supervisedStudents: Array<User>;
    researchAreas: Array<ResearchArea>;
    projectStatistics: ProjectStatistics;
}

export interface ProjectStatistics {
    projects: Array<ProjectBrowserModel>;
    numberOfProjects: number;
    averageNumberOfDaysForGrading: number | null;
}

export interface IAdminDocument {
    _id?: string;
    name: string;
    userRole: UserRole | undefined;
    intakes: Array<Intake>;
    programs: Array<Program | undefined>;
    description: string;
    displayOn: Array<AdminDocumentDisplayOnEnum>;
    document?: IDocument;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface IAdminText {
    _id?: string;
    title: string;
    userRole: UserRole | undefined;
    intakes: Array<Intake>;
    programs: Array<Program | undefined>;
    description: string;
}

export enum AdminDocumentDisplayOnEnum {
    HelpPage = 'HelpPage',
    PinBoard = 'PinBoard',
}

